'use strict';
(function() {

	class InstamapsUtils {
		
		constructor(){
			this.isFirstZoom = true;	
		}

		greets (nombre) {
			return `Hello ${nombre} que tal? ${this.isFirstZoom}`;
		}

		static saludo (nombre) {
			return `Hola ${nombre} que tal? ${this.isFirstZoom}`;
		}

	}

	class Validator {
		constructor (){

		}

		static isValidEmailAddress (emailAddress) {
			var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
			return pattern.test(emailAddress);
		}

		static isValidURL (url) {
			var pattern = /((http(s)?|ftp):\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z0-9]{2,6}\b([-a-zA-Z0-9@%_:?\+.~#&//=]*)/;
			return pattern.test(url);
		}

		static isImgURL (str) {
			return (/\.(gif|jpg|jpeg|png)$/i).test(str);
		}

		static isBusinessId (str){
			var pattern = new RegExp('^[0-9a-f]{32}$');
			return pattern.test(str);
		}

		static isBlank (str) {
			return (!str || (/^\s*$/).test(str));
		}

		static isDefaultMapTitle (str){
			var pattern = /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])[_](?:2[0-3]|[01]?[0-9]):[0-5][0-9]:[0-5][0-9]$/;
			return pattern.test(str);
		}

		static isValidValue (value){
			return (value !== "undefined" && 
			value !== undefined && 
			value !== null && 
			value !== " " && 
			value !== "" && 
			value !== "null" && 
			value !== -1 && 
			value !== "-1");
		}

		static isValidValueNotWKT (value){
			return Validator.isValidValue(value) && !Validator.isWKT(value);
		}

		//antes se usaba $(location).attr('href') para el location
		static isVisorApp (location){
			var isVisor = (-1 != location.indexOf('instavisor/')) || (-1 != location.indexOf('visor.html'));
			return isVisor;
		}

		//antes era getModeMapa
		//antes se usaba $(location).attr('href') para el location 
		static isModeMapa (location){
			return (location.indexOf('/mapa.html')!=-1);
		}

		//antes era validateWkt
		static isWKT (txt){
			var isWkt = false;
			if (typeof (txt) == "string") {
				isWkt = txt.indexOf("POLYGON")>-1 || txt.indexOf ("POINT")>-1 || txt.indexOf("LINE")>-1;
			}	
			return isWkt;
		}

		//No tiene test
		static isChrome (){
			var isChromium = window.chrome,
			vendorName = window.navigator.vendor;
			var _hoSoc=false;
			
			if(isChromium !== null && isChromium !== undefined && vendorName === "Google Inc.") {
				_hoSoc=true;
			}
		
			return _hoSoc;	
		}

		static isNumber (value, inverted) {

			var isInverted = inverted || false;

			if(isInverted)
				return (0 < (value.match(/^(\d+|\d{1,3}([,]\d{3})*)([\.]\d+)?$/) || []).length);
			else
				return (0 < (value.match(/^(\d+|\d{1,3}([\.]\d{3})*)([,]\d+)?$/) || []).length);

		}

		static isRandomUser (user){
			var isRandom = false;
			if (user && user.indexOf("random_") != -1 && user.indexOf("random_") == 0){
				isRandom = true;
			}
			return isRandom;
		}

		//NO TEST
		static isEmpty (value) {
			return _.isEmpty(value);
		}
	}

	InstamapsUtils.Validator = Validator;

	class Colors {
		constructor (){

		}

		static isHexColor (color){
			var pattern = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i;
			return pattern.test(color);
		}

		//TODO revisar porque se retorna negro si falla la regex
		static hexToRgb (hex) {
			if(Colors.isHexColor(hex)) {
				var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
				return result ? {
					r: parseInt(result[1], 16),
					g: parseInt(result[2], 16),
					b: parseInt(result[3], 16)
				} : {r:0,g:0,b:0};
			}else {
				return null;
			}
		}

		//TODO revisar porque se retorna negro si falla la regex
		static hexToRgba (hex, opacity) {
			if(Colors.isHexColor(hex)) {
				var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
				return result ? {
					r: parseInt(result[1], 16),
					g: parseInt(result[2], 16),
					b: parseInt(result[3], 16),
					a: opacity,
				} : {r:0,g:0,b:0,a:1};
			}else {
				return null;
			}
		}

		static getRgbaText(rgba){
			if (Colors.isHexColor(rgba)){
				return  Colors.getRgbaText(Colors.hexToRgba (rgba,1));
			}
			else {
				if (rgba!==null && rgba!==undefined && rgba.r !== undefined && rgba.g !== undefined && rgba.b !== undefined && rgba.a !== undefined) {
					return `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${rgba.a})`;
				}
				else {
					return `rgba(0,0,0,0)`;
				}
			}
			
		}

		static getRgbText(rgb){
			if (Colors.isHexColor(rgb)){
				return Colors.getRgbText(Colors.hexToRgb (rgb));
			}
			else {
				if (rgb!==null && rgb!==undefined && rgb.r !== undefined && rgb.g !== undefined && rgb.b !== undefined) {
					return `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`;
				}
				else return `rgb(0,0,0)`;
			}
		}

		static hex (x) {
			var hexDigits = new Array("0","1","2","3","4","5","6","7","8","9","a","b","c","d","e","f");
			return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
		}

		static rgb2hex (rgb){
			/**Function to convert hex format to a rgb color (incloent si passes transparencia o no)*/
			if (Colors.isHexColor(rgb)){
				return rgb;
			}
			else {
				rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
				return (rgb && rgb.length === 4) ? "#" +
				("0" + parseInt(rgb[1],10).toString(16)).slice(-2) +
				("0" + parseInt(rgb[2],10).toString(16)).slice(-2) +
				("0" + parseInt(rgb[3],10).toString(16)).slice(-2) : '';
			}
		}

		static getRgbAlpha (rgba){
			/**Funcio per obtenir la transparencia d'un rgb*/
			try{
				var alpha=rgba.replace(/^.*,(.+)\)/,'$1');
				return parseFloat(alpha);
			}catch(e){
				return null;
			}
		}

	}
	
	InstamapsUtils.Colors = Colors;

	class Getters {
		constructor (){

		}

		static getRamdomFromArray (array) {
			try {
				return array[Math.floor(Math.random() * array.length)];
			} catch (error) {
				return null;
			}
		}

		static randomString(length){
			return Getters.randomStringAux(length, 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
		}

		static randomAlphaString(length){
			return Getters.randomStringAux(length, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
		}
		
		static randomStringAux (length, chars){
			var result = '';
			for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
			return result;
		}

		static getCodiUnic () {
			return  "_" + Getters.randomString(2) + Math.floor(Math.random() * (999 + 1)) ;
		}

		static getTimeStamp () {
			var now = new Date();
			return (now.getFullYear()+'/'+(
				((now.getMonth() + 1) < 10) ? ("0" + (now.getMonth() + 1)) : ((now.getMonth() + 1)))
				+ '/' +
				now.getDate() +'_'+
				((now.getHours() < 10) ? ("0" + now.getHours()) : (now.getHours()))
				+ ':' +
				((now.getMinutes() < 10) ? ("0" + now.getMinutes()) : (now.getMinutes()))
				+ ':' +
				((now.getSeconds() < 10) ? ("0" + now.getSeconds()) : (now.getSeconds()))
			);
		}

		static getRandomInt (min, max) {
			return Math.floor(Math.random() * (max - min + 1)) + min;
		}

		static treuAccentsiEspais (nomIndexacio){
			nomIndexacio=nomIndexacio.replace(/[^0-9a-zA-Z ]/g, "");
			nomIndexacio=nomIndexacio.replace(/\s/g, "-");
			return nomIndexacio;	
		}

		static shortString (str, _length){
			if(str){
				str.length > _length ?str=(str.substring(0,_length)+"..."):str;
			}
			return str;	
		}

		//TODO agregar los metodos del instamaps.data.formatter y instamaps.data.converter
		static decimalComa (nStr) {
			nStr += '';
			nStr = nStr.replace(".", ",");
		
			var x = nStr.split(',');
			var x1 = x[0];
			var x2 = x.length > 1 ? ',' + x[1] : '';
			var rgx = /(\d+)(\d{3})/;
			while (rgx.test(x1)) {
		
				x1 = x1.replace(rgx, '$1' + '.' + '$2');
			}
			return x1 + x2;
		}

		static parseUrlTextPopUp (txt,key,isImage){
			if (key!=undefined && txt===undefined) return "-";
			if (key.toLowerCase() != "geomorigen"){
				var parseText = "";
				var isWkt = Validator.isWKT(txt);
				if (!isWkt) {
					if (isImage) {
						var img = Getters.getUrlImg(txt);						
						return img;
					}
					else if(isNaN(txt) && (key=='link' || key=='Web')){
						  if( Validator.isImgURL(txt)){
							  parseText = '<a href="'+(txt.replace("\>","").replace("src=","").replace("\"","").replace("'>","").replace("'","").replace("</img>","").replace(" ","")).replace("'","")+'" data-lightbox="image-1"><img src="'+txt+'"/></a>';
						  }else if( txt.match("^http")){
							  parseText = '<a target="_blank" href="'+txt+'"/>'+txt+'</a>';
						  }else{
							  parseText = '<a target="_blank" href="http://'+txt+'"/>'+txt+'</a>';
						  }
						  return parseText;
					}
				
					if (isNaN(txt)) {
						if (typeof txt === "string") {
						  	if(txt.indexOf("href")!= -1 || txt.indexOf("<a")!= -1 || txt.indexOf("<img")!= -1 || txt.indexOf("<iframe")!= -1 ){
								var countImg = Getters.countOccurences(txt,"<img"); // 2
								var isMultipleTag = Getters.isMultipleTag(txt);
								if (txt.indexOf("<img")!= -1 && countImg===1 && !isMultipleTag){
									var img = Getters.getUrlImg(txt);						
									return img;
								}
								else  return txt;
						  	}
						  	else if (isImage) {
								var img = Getters.getUrlImg(txt);						
								return img;
						  	}
						}
						else return txt;
					}
				
					var lines = txt.split(/\n/);
					lines.forEach(function(line){
						var lwords = line.split(" ");
						lwords.forEach(function(word){
							  var text;
							  if(isNaN(txt) ){
									 if (Validator.isValidURL(word) && typeof word === "string"){
											 var hasProtocol = ((-1 != word.indexOf('http://')) || (-1 != word.indexOf('https://')) || (-1 != word.indexOf('ftp://')))
											if(Validator.isImgURL(word)){
												  var url=(word.replace("\>","").replace("src=","").replace("\"","").replace("'>","").replace("'","").replace("</img>","").replace(" ",""));
												  text = '<a href="'+(!hasProtocol ? "http://" + url : url)+'" data-lightbox="image-1"><img  src="'+(!hasProtocol ? "http://" + word : word)+'" alt=\"img\" class=\"popup-data-img\"/></a>';
											}
											else if (word.indexOf("html?") != -1){
												   text = "<iframe width=\"100%\" height=\"200\" frameborder=\"0\" marginheight=\"0\""+
																"marginwidth=\"0\" src=\""+(!hasProtocol ? "http://" + word : word)+"\"></iframe>";
											}else if (txt.indexOf("<video")==-1){
												   text = "<a href=\""+(!hasProtocol ? "http://" + word : word)+"\" target=\"_blank\">"+word.replace("http://", "")+"</a>";
											}
											else text=word;
									 }else{
											text = word;
									 }
					
							  }else{
									 text = word;
							  }
							  parseText+=" "+text;
						});
			
						if("" == line)
							parseText += "<br />";
						else
							parseText += "\n";
			
					});
					return parseText;
				}
				else {
					return "isWkt";
				}
			}
		}

		static isMultipleTag(txt){
			if (txt.indexOf("<img")!==-1 && txt.indexOf("href")!==-1){
				return true;
			}	
			else return false;
		}

		static countOccurences(string, word) {
			return string.split(word).length - 1;
		 }
		//NO TEST
		static cleanDriveUrl(txt){
			if (txt.indexOf("https://drive.google.com/file/d/")!=-1) {
				txt=txt.replace("/view","");
				 txt = txt.replace("https://drive.google.com/file/d/", "https://drive.google.com/uc?export=view&id=");
			}
			if (txt.indexOf("https://drive.google.com/open?id=")!=-1) {
				txt = txt.replace("https://drive.google.com/open?id=", "https://drive.google.com/uc?export=view&id=");
			}
			if (txt.indexOf("usp=sharing")!=-1){
				txt = txt.replace("?usp=sharing","");
			}
			if (txt.indexOf("sharepoint")!==-1 && txt.indexOf("download")===-1){
				txt = txt+"&download=1";
			}
			return txt;
		}

		//NO TEST
		static getUrlImg(txt){
			if (txt.indexOf("<img")!= -1){
				try{
						txt = Getters.cleanDriveUrl(txt);
						var src = txt.substring(txt.indexOf("src"),txt.length);
						src = src.replace("\>","").replace("src=","").replace("\"","").replace("'>","").replace("'","").replace("</img>","").replace(" ","").replace("'","");
						src = src.replaceAll(" ","").replaceAll("&nbsp;","");
						if (src.indexOf("width")>-1) src = src.substring(0,src.indexOf("width"));
						var lightbox="<a href=\""+src+"\" data-lightbox='image-1'>";
					  if (txt.indexOf(".jpg>")>-1) {
						  txt=txt.replace(".jpg>",".jpg'>");
					  }
						txt=lightbox+txt+"</a>";
						return txt;
				}catch(e){
					console.debug(e);
				}
			}
			else {
				txt = Getters.cleanDriveUrl(txt);
				var lightbox="<a href='"+txt+"' data-lightbox='image-1'>";
				var img = lightbox +"<img src='";				
				img += txt;
				img += "'></a>";
				return img;
			}
		}

		static getSimpleUrlImg(txt){
			if (txt!==undefined && txt.indexOf("<img")!= -1){
				try{
						txt = Getters.cleanDriveUrl(txt);
						var src = txt.substring(txt.indexOf("src"),txt.length);
						src = src.replace("\>","").replace("src=","").replace("\"","").replace("'>","").replace("'","").replace("</img>","").replace(" ","").replace("'","");						
						
					  if (txt.indexOf(".jpg>")>-1) {
						  txt=txt.replace(".jpg>",".jpg'>");
					  }
					return txt;
				}catch(e){
					console.debug(e);
				}
			}
			else if (txt!==undefined){
				var img = "<img src='";
				txt = Getters.cleanDriveUrl(txt);
				img += txt;
				img += "'>";
				return img;
			}
			else return "";
		}

		static getIconaUrlImg(txt){
			if (txt!==undefined && txt.indexOf("<img")!= -1){
				try{
						txt = Getters.cleanDriveUrl(txt);
						var src = txt.substring(txt.indexOf("src"),txt.length);
						src = src.replace("\>","").replace("src=","").replace("\"","").replace("'>","").replace("'","").replace("</img>","").replace(" ","").replace("'","");						
					  if (txt.indexOf(".jpg>")>-1) {
						  txt=txt.replace(".jpg>",".jpg'>");
					  }
					  txt = txt.replace(">"," style='max-width:100px !important'>");
					return txt;
				}catch(e){
					console.debug(e);
				}
			}
			else if (txt!==undefined){
				var img = "<img src='";
				txt = Getters.cleanDriveUrl(txt);
				img += txt;
				img += "' width='100px;'>";
				return img;
			}
			else return "";
		}

		static isImageTxt(textEtiqueta,propImatge,campEtiqueta){
			var campEtiquetamod = campEtiqueta.replaceAll(" ","_");
			return (textEtiqueta!==undefined && (textEtiqueta.indexOf("<img")>-1 || textEtiqueta.indexOf(".png")>-1 || textEtiqueta.indexOf(".jpg")>-1)) 
			|| (propImatge!==undefined && propImatge!="" && (propImatge[campEtiqueta]==="imatge" || propImatge[campEtiqueta.toLowerCase()]==="imatge"
			|| propImatge[campEtiquetamod]==="imatge"));								
		}

		static isIconaTxt(textEtiqueta,propIcona,campEtiqueta){
			var campEtiquetamod = campEtiqueta.replaceAll(" ","_");
			return (textEtiqueta!==undefined && (textEtiqueta.indexOf("<img")>-1 || textEtiqueta.indexOf(".png")>-1 || textEtiqueta.indexOf(".jpg")>-1)) 
			|| (propIcona!==undefined && propIcona!="" && (propIcona[campEtiqueta]==="icona" || propIcona[campEtiqueta.toLowerCase()]==="icona"
			|| propIcona[campEtiquetamod]==="icona"));
		}

		//NO TEST
		static getUrlMapa(window, cookies, domini, url_id){
			var v_url = window.location.href;
        	if (!url_id){
				if(cookies.get('userId')){
					v_url += "&id=" + cookies.get('userId');
				}
        	}
        	v_url = v_url.replace('localhost', domini);
        	v_url = v_url.replace('mapa', 'visor');
        	return v_url;
		}

	}

	InstamapsUtils.Getters = Getters;

	class Sort {
		constructor (){

		}

		static sortByKey (array, key) {
			return array.sort(function(a, b) {
				var x = a[key]; var y = b[key];
				return ((x < y) ? -1 : ((x > y) ? 1 : 0));
			});
		}

		static sortLayersByOptionsKey (array, key, isNumeric) {		
			return array.sort(function(a, b) {
				 var x = a.layer.options[key]; var y = b.layer.options[key];
				 if (isNumeric) {
					 x=parseFloat(x);
					 y=parseFloat(y);
				 }
				return ((x < y) ? -1 : ((x > y) ? 1 : 0));
			});
		}

		//TODO utilizar las utils para formatear numeros
		static sortByValueMax (a, b){
			var floatRegex = new RegExp('(^-?0\.[0-9]*[1-9]+[0-9]*$)|(^-?[1-9]+[0-9]*((\.[0-9]*[1-9]+[0-9]*$)|(\.[0-9]+)))|(^-?[1-9]+[0-9]*$)|(^0$){1}');
			var floatRegex2 = new RegExp('(^-?0\,[0-9]*[1-9]+[0-9]*$)|(^-?[1-9]+[0-9]*((\.[0-9]*[1-9]+[0-9]*$)|(\.[0-9]+)))|(^-?[1-9]+[0-9]*$)|(^0$){1}');		
			if (a!=null && b!=null) {
				var aValue;
				if (a.value!=undefined) aValue= a.value;
				else if (a.valueMax!=undefined && a.valueMin!=undefined){
					if (a.valueMax === a.valueMin) {
						aValue = a.valueMax;
					}
					else aValue=a.valueMin;
				}
				else if (a.v!=undefined) aValue=a.v;
				else aValue = a;
				var bValue;
				if (b.value!=undefined) bValue= b.value;
				else if (b.valueMax!=undefined && b.valueMin!=undefined){
					if (b.valueMax === b.valueMin) {
						bValue = b.valueMax;
					}
					else bValue=b.valueMin;
				}
				else if (b.v!=undefined) bValue=b.v;
				else bValue =b;
				var aValueStr = ""+aValue;
				var bValueStr = ""+bValue;
				
				if (aValueStr.indexOf(",")>-1){
					if (aValueStr.indexOf(".")>-1){
						aValue=aValue.replace(".","");
						aValue=aValue.replace(",",".");
					}
					else {
						aValue = aValue.replace(",",".");
					}
				}
				if (aValueStr.indexOf("-")>-1 && aValue.substring(0,aValue.indexOf("-"))!="") {
					aValue=aValue.substring(0,aValue.indexOf("-"));
					aValue=aValue.replace(" ","");
				}
		
				if (bValueStr.indexOf(",")>-1){
					if (bValueStr.indexOf(".")>-1){
						bValue=bValue.replace(".","");
						bValue=bValue.replace(",",".");
					}
					else {
						bValue = bValue.replace(",",".");
					}
				}
				if (bValueStr.indexOf("-")>-1 && bValue.substring(0,bValue.indexOf("-"))!="") {
					bValue=bValue.substring(0,bValue.indexOf("-"));
					bValue=bValue.replace(" ","");
				}
				if (aValue.indexOf("/")===-1 && bValue.indexOf("/")===-1 && floatRegex.test(aValue) && floatRegex.test(bValue)) {			
					return (aValue-bValue);
				}
				else if (aValue.indexOf("/")===-1 && bValue.indexOf("/")===-1 && floatRegex2.test(aValue) && floatRegex2.test(bValue)) {		
					return (aValue-bValue);
				}
				else {//issue dates and floats
					var date1=new Date(aValue);
					var date2=new Date(bValue);
					if (date1!=="Invalid Date" && date2!=="Invalid Date"){
						try{
							var array1 = aValue.split("/");
							var array2 = bValue.split("/");
							var data1_ok = new Date(array1[2],array1[1]-1,array1[0]);
							var data2_ok = new Date(array2[2],array2[1]-1,array2[0]);
							//comparem dates
							if (data1_ok > data2_ok) return 1;
							else if (data1_ok < data2_ok) return -1;
							else return 0;
						}
						catch(e){
							var aName = aValueStr.toLowerCase();
							var bName = bValueStr.toLowerCase();
							return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
						}
					}
					else {
						var aName = aValueStr.toLowerCase();
						var bName = bValueStr.toLowerCase();
						return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
					}
				}
				
			}
		}
	}

	InstamapsUtils.Sort = Sort;

	class Styles {
		constructor (){
		
		}

		static getColorAwesomeMarker (markerColor, defaultColor){
			if(markerColor.indexOf("punt_r")!=-1) return defaultColor;
			else if(markerColor.indexOf("orange")!=-1) return "#ffc500";
			else if(markerColor.indexOf("darkorange")!=-1) return "#ff7f0b";
			else if(markerColor.indexOf("red")!=-1) return "#ff4b3a";
			else if(markerColor.indexOf("purple")!=-1) return "#ae59b9";
			else if(markerColor.indexOf("blue")!=-1) return "#00afb5";
			else if(markerColor.indexOf("green")!=-1) return "#7cbd00";
			else if(markerColor.indexOf("darkgray")!=-1) return "#90a6a9";
			else if(markerColor.indexOf("gray")!=-1) return "#ebf0f1";
		}

		static getColorFromClass (classe){
			switch (classe) {
				case 'orange':
				  	return '#ffc500';
				case 'darkorangeb':
				  	return '#ff7f0b';
				case 'red':
				  	return '#ff4b3a';
				case 'purple':
				  	return '#ae59b9';	
				case 'blue':
				  	return '#00afb5';
				case 'green':
				  	return '#7cbd00';
				case 'darkgray':
				  	return '#90a6a9';
				case 'gray':
				  	return '#ebf0f1';		  
				default:
					return '#ffc500';
			} 		
		}

		static retornaEstilaDO (defaultPunt) {
			var estil = { radius : 6, fillColor : "#FC5D5F", color : "#ffffff", weight : 2, opacity : 1, fillOpacity : 0.8, isCanvas: true };
			if(defaultPunt){
				if(!defaultPunt.options.isCanvas) {
		
					estil.fillColor = Styles.getColorFromClass(defaultPunt.options.markerColor);
			
				} else {
			
					estil.fillColor = defaultPunt.options.fillColor;
			
				}
			}
		
			return estil;
		}

		static getMidaFromRadius (radius){
			switch (radius) {
				case 8: 
					return 21;
				case 10: 
					return 24;
				case 12: 
					return 30;
				case 14: 
					return 34;
				default:
					return 16;
			}
		}

		static getMidaFromFont (font){
			switch (font) {
				case 'font15': 
					return 30;
				case 'font12': 
					return 24;
				case 'font11': 
					return 21;
				case 'font9': 
					return 16;
				default:
					return 34;
			}
		}

		static getRadiusFromMida (mida){
			switch (mida) {
				case '21px': 
					return 8;
				case '24px': 
					return 10;
				case '30px': 
					return 12;
				case '34px': 
					return 14;
				default:
					return 6;
			}
		}

		static getPaddingTopFromRadius (mida){
			var padding_top = "5px";
			if (mida<=22) padding_top="5px";
			else if (mida>22 && mida <=31) padding_top="10px";
			else if (mida>31 && mida<=39) padding_top="15px";
			else if (mida>39 && mida<=47) padding_top="25px";
			else if (mida>47) padding_top="35px";
			return padding_top;
		}

		//NO TEST
		static getSvgFromRadius (radius, color, location){
			var stringStyle =	'<svg ';
			var mida = radius;
			var x=0;
			var y=0;
			var transform = 'transform:translate(0px,'+radius+'px);'; 
			if  (radius <= 6) {	
				if (Validator.isVisorApp(location)){
					stringStyle += 'height="8px" width="8px">';
				}
				else {
					stringStyle += 'height="8px">';
				}
				transform = 'transform:translate(0px,8px);'; 
				mida=8;
			}
			else {
				if (Validator.isVisorApp(location)){
					stringStyle += 'height="'+radius+'" width="'+radius+'">';
				}
				else {
					stringStyle += 'height="'+radius+'px" >';
				}
			}
			stringStyle += '<circle cx="'+x+'" cy="'+y+'" r="'+mida+'" '+
			'style="stroke:white; fill:'+Colors.getRgbText(color)+';'+transform+'"></circle>'+
			'</svg>';
			return stringStyle;
		}

		static getSvgForLegendFromRadius (radius, color, location){
			var stringStyle =	'<svg ';
			var mida = radius;
			var x=0;
			var y=0;
			if  (radius <= 6) mida=8;
			var transform = 'transform:translate(0px,'+mida+'px);'; 
			stringStyle += 'height="'+mida+'px">';
			transform = 'transform:translate(0px,'+mida+'px);'; 
			//mida=10;
			
			stringStyle += '<circle cx="'+x+'" cy="'+y+'" r="'+mida+'" '+
			'style="stroke:white; fill:'+Colors.getRgbText(color)+';'+transform+'"></circle>'+
			'</svg>';
			return stringStyle;
		}

		//NO TEST
		static getLineStyleFromToolbar (id, constants){
			var defLine = document.getElementById(id).getContext("2d");
			var estilTMP = constants.default_line_style;
			estilTMP.color = defLine.strokeStyle;
			estilTMP.weight = defLine.lineWidth;
			estilTMP.tipus = t_polyline;
			return estilTMP;
		}

		//NO TEST
		static getPolygonStyleFromToolbar (id, constants){
			var defPol = document.getElementById(id).getContext("2d");
			var fillColor = defPol.fillStyle;
			if(fillColor.indexOf("rgb")!=-1) {
				fillColor = Colors.rgb2hex(defPol.fillStyle);
			}	
			var estilTMP = constants.default_area_style;
			estilTMP.fillColor = fillColor;
			estilTMP.fillOpacity = (Math.round(Colors.getRgbAlpha(defPol.fillStyle)*100))/100;
			estilTMP.weight = defPol.lineWidth;
			estilTMP.color = defPol.strokeStyle;
			estilTMP.tipus = t_polygon;
			return estilTMP;
		}

		//NO TEST
		static getMarkerStyleFromToolbar (id, constants){
			var element = document.getElementById(id);
			//var styleProps = $(id).css(["width","height","color","background-color","font-size"]); //"#div_punt"
			var styleProps = getComputedStyle(element);
			//var punt_class = $(id).attr("class");
			var punt_class = element.getAttribute("class");
			var lclass = punt_class.split(" ");
			var icon = {};
			//Si es punt inicial per defecte
			if(punt_class == constants.dibuix_punt){
				icon.options = {
					icon: "",//glyph
					iconColor: "#000000",
					isCanvas: false,
					className: "awesome-marker",
					markerColor: 'orange',
					tipus: constants.t_marker,
					iconAnchor: new L.Point(14, 42),
					iconSize : new L.Point(28, 42),
					shadowSize : new L.Point(36, 16),
					divColor: 'transparent',
					opacity: 1,
					fillOpacity: 1
				};
			}else if (punt_class.indexOf("punt_r") != -1){
		
				//Es punt sense glyphon, CANVAS
				if(!lclass[3] || lclass[3] === "fa-"){
					icon.options = {
						icon: "",//glyph
						iconColor: Colors.rgb2hex(styleProps.getPropertyValue("color")),
						fillColor: Colors.rgb2hex(styleProps.getPropertyValue("background-color")),
						radius: Styles.getRadiusFromMida(styleProps.getPropertyValue("width")),
						isCanvas: true,
						tipus: constants.t_marker,
						shadowSize : new L.Point(1, 1),
						divColor: Colors.rgb2hex(styleProps.getPropertyValue("background-color")),
						opacity: 1,
						fillOpacity: 0.9,
						color: "#ffffff",
						stroke: true,
						weight: 2,
						borderColor : "#ffffff",					
					};
				}else{//Es punt amb glyphon
					var iconGlyph = "";
					if(lclass[3]) iconGlyph = lclass[3];
					var font = " font"+styleProps["font-size"].substring(0,2);
					var num = styleProps.getPropertyValue("width");
					num = parseInt(num);
					punt_class = punt_class.replace('awesome-marker-web awesome-marker-icon-','');
					if(punt_class.indexOf("fa fa-")!=-1){
						punt_class=punt_class.replace('fa fa-','');
					}
					if(punt_class.indexOf(iconGlyph.substring(3))!=-1){
						punt_class=punt_class.replace(iconGlyph.substring(3),'');
					}
					if (punt_class.indexOf("font")!=-1){
						punt_class = punt_class.substring(0,punt_class.indexOf(" ")) ;
					}
					punt_class = punt_class.trim();

					icon.options = {
						icon: iconGlyph.substring(3) + font,//glyph
						iconColor: Colors.rgb2hex(styleProps.getPropertyValue("color")),
						divColor: Colors.rgb2hex(styleProps.getPropertyValue("background-color")),
						isCanvas: false,
						markerColor: punt_class,
						tipus: constants.t_marker,
						shadowSize : new L.Point(1, 1),	
						iconAnchor : new L.Point(parseInt(num/2), parseInt(num/2)),
						iconSize : new L.Point(num,num),
						opacity: 1,
						fillOpacity: 0.9,
						color: "#ffffff",
						stroke: true,
						weight: 2,
						borderColor : "#ffffff",
						radius: Styles.getRadiusFromMida(styleProps.getPropertyValue("width")),
					};
				}
			}else{//Pintxo
				var markerColor = (lclass[1].split("-"))[3];
				var iconGlyph = "";
				if(lclass[3]) iconGlyph = lclass[3];
				icon.options = {
					icon: iconGlyph.substring(3),//glyph
					iconColor: Colors.rgb2hex(styleProps.getPropertyValue("color")),
					isCanvas: false,
					className: "awesome-marker",
					markerColor: markerColor,
					tipus: constants.t_marker,
					iconAnchor: new L.Point(14, 42),
					iconSize : new L.Point(28, 42),
					shadowSize : new L.Point(36, 16),
					divColor: 'transparent',
					opacity: 1,
					fillOpacity: 1
				};
			}
			
			return icon;
		}

		static getMarkerColorFromStyles(feature){
			var styles = feature.styles;
			var props = feature.properties;
			if (styles!==undefined) {
				if (styles.icon!==undefined){
					var auxOptions = styles.icon.options;
					return auxOptions.markerColor;
				}
			}else if (options!=undefined && props["marker-color"]!=undefined){	
				return props["marker-color"];
			}
		}

		static getIconFromStyles(feature){
			var styles = feature.styles;
			if (styles!==undefined) {
				if (styles.icon!==undefined){
					var auxOptions = styles.icon.options;
					return auxOptions.icon;
				}
			}
		}

		static getOptionsStyleFromFeature(feature,latlng){
			var geometryType = feature.geometry.type;
			var styles = feature.styles;
			var props = feature.properties;
			if (geometryType === "Point"){
				if (styles!==undefined) {
					if (styles.icon!==undefined){
						var auxOptions = styles.icon.options;
						latlng.options.iconAnchor= new L.Point(14, 42);
						latlng.options.iconSize = new L.Point(28, 42);
						latlng.options.shadowSize = new L.Point(36, 16);
						latlng.options.divColor='transparent';
						latlng.options.isCanvas=false;	
						latlng.options.markerColor=auxOptions.markerColor;
						latlng.options.iconColor=auxOptions.iconColor;		
						latlng.options.iconFons='awesome-marker-web awesome-marker-icon-orange';
					}
					else {
						latlng.options.color=styles.color;
						latlng.options.fillColor=styles.fillColor;
						latlng.options.fillOpacity=styles.fillOpacity;
					}
				}
				else if (props!=undefined && props["marker-color"]!=undefined){	
					latlng.options.color= props["marker-color"];
					latlng.options.fillColor= props["marker-color"];
					latlng.options.fillOpacity=0.8;	
				}
				else {
					latlng.options.color="#ffffff";
					latlng.options.fillColor="#FC5D5F";
					latlng.options.fillOpacity=0.8;
				}
			}
			if  (geometryType === "LineString"){
				if (styles!==undefined) {
					latlng.options.color=styles.color;
					latlng.options.fillColor=styles.fillColor;
					latlng.options.opacity=styles.opacity* 100;
					latlng.options.weight = styles.weight;
				}
				else if (props!=undefined && props.stroke!=undefined){
					latlng.options.color = props["stroke"];
					latlng.options.fillColor = props["stroke"];
					latlng.options.opacity =  props["stroke-opacity"];
					latlng.options.weight= props["stroke-width"];
				}
				else {
					latlng.options.color='#FF0000';
					latlng.options.fillColor='#FF0000';
					latlng.options.opacity=1;
					latlng.options.weight = 3;
				}
			}
			if (geometryType === "Polygon"){
				if (styles!==undefined) {
					latlng.options.weight = styles.weight;
					latlng.options.fillColor = styles.fillColor;
					latlng.options.color = styles.color;
					latlng.options.fillOpacity = styles.fillOpacity;
					latlng.options.opacity =  styles.fillOpacity;
					var borderWidth = 2;
					if (styles.borderWidth) borderWidth=styles.borderWidth;			
					else if (styles.weight) borderWidth = styles.weight;
					if (typeof borderWidth === 'string') borderWidth=parseInt(borderWidth);
					latlng.options.borderWidth=borderWidth;
					latlng.options.borderColor= styles.color;
				}
				else if (props!=undefined && props.stroke!=undefined){
					latlng.options.color = props["stroke"];
					latlng.options.fillColor =  props["fill"];
					latlng.options.weight = props["stroke-width"];
					latlng.options.fillOpacity = props["fill-opacity"];
					latlng.options.opacity =  props["fill-opacity"];
					latlng.options.borderColor= props["stroke"];
				}
				else {
					latlng.options.weight = 3;
					latlng.options.fillColor = "rgb(255,196,0)";
					latlng.options.color =  '#FF0000';
					latlng.options.fillOpacity = 0.5;
					latlng.options.opacity =  0.5;
					latlng.options.borderWidth=3;
					latlng.options.borderColor=  '#FF0000';
				}
			}
			return latlng;
		}
	}

	InstamapsUtils.Styles = Styles;

	class Geo {
		constructor (){
		
		}

		static stringBBOXtoArray (strBBOX){
			var _BBOX = strBBOX.split(",");
			return _BBOX;
		}

		//NO TEST
		static getAreaLayer (layer, L){
			var totalArea = 0,
				lLatLngs;
		
			if (layer._layers) {
				layer.eachLayer(function (layer) {
					totalArea += Geo.getAreaLayer(layer);
				});
		
			}else if(layer.length > 0){
				for(var i=0; i<layer.length;i++){
					lLatLngs = new L.latLng(0,0);
					if(layer[i].lat && layer[i].lng){
						lLatLngs = new L.latLng(layer[i].lat,layer[i].lng);
					}
					totalArea += L.GeometryUtil.geodesicArea(lLatLngs);
				}
			}else{
				try{
					lLatLngs = layer.getLatLngs();
					totalArea = L.GeometryUtil.geodesicArea(lLatLngs);
				}
				catch (e){
					
				}
			}	return totalArea;
		}
		
		//NO TEST
		static calculateArea (layer, L){
			var mida=0;
			try{
			 	mida = L.GeometryUtil.geodesicArea(layer.getLatLngs()[0]);
				mida = L.GeometryUtil.readableArea(mida,true);
			}catch(e){
				
			}
			return mida;
		}
		
		//NO TEST
		static calculateAreaWithoutHa (layer, L){
			var mida=0;
			try{
				 mida = Geo.calculateArea(layer,L);				 
				 mida= mida.replace(" ha","");
			}catch(e){

			}
			return mida;
		}

		//NO TEST
		static calculateDistance (lLatLngs, L){
			var totalDistance = 0;
			var lastPoint;
			if(lLatLngs.length>0) lastPoint = lLatLngs[0];
		
			lLatLngs.forEach(function(point){
				totalDistance += point.distanceTo(lastPoint);
				lastPoint = point;
			});
			return L.GeometryUtil.readableDistance(totalDistance, true);
		}

		//NO TEST
		static calculateDistanceWithoutKm (lLatLngs, L){
			var readable =  Geo.calculateDistance(lLatLngs, L);
			return readable.replace(" km","");
		}

		//NO TEST
		static latLngTransformation (lat, lng, crs) {
			var auxLat = lat.toFixed(5);
			var auxLng = lng.toFixed(5);
			var _CRS = crs.project( {lat:auxLat, lng:auxLng} );			
			return {x: _CRS.x.toFixed(2), y: _CRS.y.toFixed(2)};
		}

		static transformTipusGeometry (geometrytype, constants){
			var ftype = geometrytype;
			if (ftype){
				ftype = ftype.toLowerCase();
				if (ftype === constants.t_point){
					ftype = constants.t_marker;
				}else if (ftype === constants.t_linestring){
					ftype = constants.t_polyline;
				}else if (ftype === constants.t_multilinestring){
					ftype = constants.t_polyline;
				}else if (ftype === constants.t_multipolygon){
					ftype = constants.t_polygon;
				}
			}
			return ftype;
		}
		
		static isMultiPolygon(capaEdicio){
			Object.keys(capaEdicio._layers).forEach(function (item) {

			});
		}
		
	}

	InstamapsUtils.Geo = Geo;

	class Dom {
		constructor (){
		
		}

		//NO TEST
		static get_html_translation_table (table, quote_style) {
			//discuss at: http://phpjs.org/functions/get_html_translation_table/
			//original by: Philip Peterson
			//revised by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
			//bugfixed by: noname
			//bugfixed by: Alex
			//bugfixed by: Marco
			//bugfixed by: madipta
			//bugfixed by: Brett Zamir (http://brett-zamir.me)
			//bugfixed by: T.Wild
			//improved by: KELAN
			//improved by: Brett Zamir (http://brett-zamir.me)
			//input by: Frank Forte
			//input by: Ratheous
			//note: It has been decided that we're not going to add global
			//note: dependencies to php.js, meaning the constants are not
			//note: real constants, but strings instead. Integers are also supported if someone
			//note: chooses to create the constants themselves.
			//example 1: get_html_translation_table('HTML_SPECIALCHARS');
			//returns 1: {'"': '&quot;', '&': '&amp;', '<': '&lt;', '>': '&gt;'}
			var entities = {},
			hash_map = {},
			decimal;
			var constMappingTable = {},
			constMappingQuoteStyle = {};
			var useTable = {},
			useQuoteStyle = {};
			//Translate arguments
			constMappingTable[0] = 'HTML_SPECIALCHARS';
			constMappingTable[1] = 'HTML_ENTITIES';
			constMappingQuoteStyle[0] = 'ENT_NOQUOTES';
			constMappingQuoteStyle[2] = 'ENT_COMPAT';
			constMappingQuoteStyle[3] = 'ENT_QUOTES';
			useTable = !isNaN(table) ? constMappingTable[table] : table ? table.toUpperCase() : 'HTML_SPECIALCHARS';
			useQuoteStyle = !isNaN(quote_style) ? constMappingQuoteStyle[quote_style] : quote_style ? quote_style.toUpperCase() :
			'ENT_COMPAT';
			if (useTable !== 'HTML_SPECIALCHARS' && useTable !== 'HTML_ENTITIES') {
				throw new Error('Table: ' + useTable + ' not supported');
				//return false;
			}
			entities['38'] = '&amp;';
			if (useTable === 'HTML_ENTITIES') {
			entities['160'] = '&nbsp;';
			entities['161'] = '&iexcl;';
			entities['162'] = '&cent;';
			entities['163'] = '&pound;';
			entities['164'] = '&curren;';
			entities['165'] = '&yen;';
			entities['166'] = '&brvbar;';
			entities['167'] = '&sect;';
			entities['168'] = '&uml;';
			entities['169'] = '&copy;';
			entities['170'] = '&ordf;';
			entities['171'] = '&laquo;';
			entities['172'] = '&not;';
			entities['173'] = '&shy;';
			entities['174'] = '&reg;';
			entities['175'] = '&macr;';
			entities['176'] = '&deg;';
			entities['177'] = '&plusmn;';
			entities['178'] = '&sup2;';
			entities['179'] = '&sup3;';
			entities['180'] = '&acute;';
			entities['181'] = '&micro;';
			entities['182'] = '&para;';
			entities['183'] = '&middot;';
			entities['184'] = '&cedil;';
			entities['185'] = '&sup1;';
			entities['186'] = '&ordm;';
			entities['187'] = '&raquo;';
			entities['188'] = '&frac14;';
			entities['189'] = '&frac12;';
			entities['190'] = '&frac34;';
			entities['191'] = '&iquest;';
			entities['192'] = '&Agrave;';
			entities['193'] = '&Aacute;';
			entities['194'] = '&Acirc;';
			entities['195'] = '&Atilde;';
			entities['196'] = '&Auml;';
			entities['197'] = '&Aring;';
			entities['198'] = '&AElig;';
			entities['199'] = '&Ccedil;';
			entities['200'] = '&Egrave;';
			entities['201'] = '&Eacute;';
			entities['202'] = '&Ecirc;';
			entities['203'] = '&Euml;';
			entities['204'] = '&Igrave;';
			entities['205'] = '&Iacute;';
			entities['206'] = '&Icirc;';
			entities['207'] = '&Iuml;';
			entities['208'] = '&ETH;';
			entities['209'] = '&Ntilde;';
			entities['210'] = '&Ograve;';
			entities['211'] = '&Oacute;';
			entities['212'] = '&Ocirc;';
			entities['213'] = '&Otilde;';
			entities['214'] = '&Ouml;';
			entities['215'] = '&times;';
			entities['216'] = '&Oslash;';
			entities['217'] = '&Ugrave;';
			entities['218'] = '&Uacute;';
			entities['219'] = '&Ucirc;';
			entities['220'] = '&Uuml;';
			entities['221'] = '&Yacute;';
			entities['222'] = '&THORN;';
			entities['223'] = '&szlig;';
			entities['224'] = '&agrave;';
			entities['225'] = '&aacute;';
			entities['226'] = '&acirc;';
			entities['227'] = '&atilde;';
			entities['228'] = '&auml;';
			entities['229'] = '&aring;';
			entities['230'] = '&aelig;';
			entities['231'] = '&ccedil;';
			entities['232'] = '&egrave;';
			entities['233'] = '&eacute;';
			entities['234'] = '&ecirc;';
			entities['235'] = '&euml;';
			entities['236'] = '&igrave;';
			entities['237'] = '&iacute;';
			entities['238'] = '&icirc;';
			entities['239'] = '&iuml;';
			entities['240'] = '&eth;';
			entities['241'] = '&ntilde;';
			entities['242'] = '&ograve;';
			entities['243'] = '&oacute;';
			entities['244'] = '&ocirc;';
			entities['245'] = '&otilde;';
			entities['246'] = '&ouml;';
			entities['247'] = '&divide;';
			entities['248'] = '&oslash;';
			entities['249'] = '&ugrave;';
			entities['250'] = '&uacute;';
			entities['251'] = '&ucirc;';
			entities['252'] = '&uuml;';
			entities['253'] = '&yacute;';
			entities['254'] = '&thorn;';
			entities['255'] = '&yuml;';
			}
			if (useQuoteStyle !== 'ENT_NOQUOTES') {
				entities['34'] = '&quot;';
			}
			if (useQuoteStyle === 'ENT_QUOTES') {
				entities['39'] = '&#39;';
			}
			entities['60'] = '&lt;';
			entities['62'] = '&gt;';
			//ascii decimals to real symbols
			for (decimal in entities) {
				if (entities.hasOwnProperty(decimal)) {
					hash_map[String.fromCharCode(decimal)] = entities[decimal];
				}
			}
			return hash_map;
		}

		//NO TEST
		static htmlentities (string, quote_style, charset, double_encode) {
			//  discuss at: http://phpjs.org/functions/htmlentities/
			// original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
			//  revised by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
			//  revised by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
			// improved by: nobbler
			// improved by: Jack
			// improved by: Rafał Kukawski (http://blog.kukawski.pl)
			// improved by: Dj (http://phpjs.org/functions/htmlentities:425#comment_134018)
			// bugfixed by: Onno Marsman
			// bugfixed by: Brett Zamir (http://brett-zamir.me)
			//    input by: Ratheous
			//  depends on: get_html_translation_table
			//   example 1: htmlentities('Kevin & van Zonneveld');
			//   returns 1: 'Kevin &amp; van Zonneveld'
			//   example 2: htmlentities("foo'bar","ENT_QUOTES");
			//   returns 2: 'foo&#039;bar'
		
			var hash_map = Dom.get_html_translation_table('HTML_ENTITIES', quote_style),
			symbol = '';
			string = string === null ? '' : string + '';
		
			if (!hash_map) {
			return false;
			}
		
			if (quote_style && quote_style === 'ENT_QUOTES') {
			hash_map["'"] = '&#039;';
			}
		
			if ( !! double_encode || double_encode === null) {
			for (symbol in hash_map) {
				if (hash_map.hasOwnProperty(symbol)) {
				string = string.split(symbol)
					.join(hash_map[symbol]);
				}
			}
			} else {
			string = string.replace(/([\s\S]*?)(&(?:#\d+|#x[\da-f]+|[a-zA-Z][\da-z]*);|$)/g, function (ignore, text, entity) {
				for (symbol in hash_map) {
				if (hash_map.hasOwnProperty(symbol)) {
					text = text.split(symbol)
					.join(hash_map[symbol]);
				}
				}
		
				return text + entity;
			});
			}
		
			return string;
		}

		//NO TEST
		static createClass (name, rules){
			var style = document.createElement('style');
			style.type = 'text/css';
			document.getElementsByTagName('head')[0].appendChild(style);
			if(!(style.sheet||{}).insertRule) 
				(style.styleSheet || style.sheet).addRule(name, rules);
			else
				style.sheet.insertRule(name+"{"+rules+"}",0);
		}

		//NO TEST
		static cleanScriptCode (txt){
			var SCRIPT_REGEX = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
			while (SCRIPT_REGEX.test(txt)) {
				txt = txt.replace(SCRIPT_REGEX, "");
			}	
			return txt;
		}

		//NO TEST
		static aturaClick (event){
			try{
				event.stopImmediatePropagation();
			}catch(err){
				console.info(err);
			}
		}

		//NO TEST
		static generarScriptMarkupGoogle (url,nom,urlImage,autor,dataPublicacio,descripcio){
			var generatedScript = "{\"@context\":\"http://schema.org\","+
				"\"@type\": \"Map\","+
				"\"name\":\""+nom+"\","+
				"\"url\":\""+url+"\","+
				"\"image\":\""+urlImage+"\","+
				"\"thumbnailUrl\":\""+urlImage+"\","+
				"\"author\": {"+
					"\"@type\":  \"Person\","+
					"\"name\":\""+autor+"\""+
				  "},"+
			   "\"datePublished\":\""+dataPublicacio+"\","+
			   "\"description\":\""+descripcio+"\""+
				"}";
			return generatedScript;
		}

		//NO TEST
		static getHtmlFromTxt (value,key,csswms){
			var html='';
			if (csswms===undefined) csswms="";
			html+='<div class="popup_data_row '+csswms+'">';
			var txt = value;
				if (isNaN(txt)) {		    				
					txt = Getters.parseUrlTextPopUp(value,key);
					if (typeof txt == 'string' || txt instanceof String) {
						if(txt.indexOf("iframe")==-1 && txt.indexOf("img")==-1){
							html+='<div class="popup_data_key">'+key+'</div>';
							html+='<div class="popup_data_value">'+txt+'</div>';
						}else{
							html+='<div class="popup_data_img_iframe">'+txt+'</div>';
						}
					}
					else{
						var txtVal=txt;
						try{
							txtVal = JSON.stringify(txt);
						}catch(e){
							
						}																	
						html+='<div class="popup_data_key">'+key+'</div>';
						html+='<div class="popup_data_value">'+txtVal+'</div>';
					}
				}
				else if (!(txt instanceof Object)){
					html+='<div class="popup_data_key">'+key+'</div>';
					html+='<div class="popup_data_value">'+txt+'</div>';
				}
			html+= '</div>';
			return html;
		}

		static createIframeHtml (url) {
			return '<div style="height: 75vh; width: 90%; margin: auto;"><iframe width="100%" height="100%" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="'+ url +'" ></iframe></div>';
		}

		static cleanOptions(props){
			if(typeof (props)=="string"){
				try {
					props = JSON.parse(props);
				}
				catch (err) {
					props = props;	
				}					
			}else{					
				props = props;	
			}
			return props;
		}

		static cleanLayerUrlOptions(layer){
			var options;
			if(typeof (layer.options) === "string"){
				options = layer.options;		
				try {
					options = JSON.parse(options);
					if (typeof(options)!=="object") {
						if (layer.url!==undefined && layer.url.indexOf("jsonfiles")>-1) options=(options.substring(1,layer.options.length-1)).replaceAll('\\"','"').replace("\"separador\":\",,","\"separador\":\",\",").replace('}"','}');
						options = JSON.parse(options);
						if (options.tipusFile!==".json" && options.style===undefined && typeof (options) !== "object"){
							if (options.indexOf(",,")>-1 || options.indexOf(",\",")>-1) options = options.replace("\"{","{").replace(",,",",\",").replace(",\",",",\\\",").replace("}\"","}").replace("}\\\"","}");				
							options = JSON.parse(options);
							if (options.style===undefined && typeof (options) !== "object"){
								if (options.indexOf("\\\"")>-1) options = options.replaceAll("\\\"","\"");
								options = JSON.parse(options);
							}
						}
					}
				}
				catch (err) {	
					try{
						if (layer.url!==undefined && layer.url.indexOf("jsonfiles")>-1) {
							options = (layer.options.substring(1,layer.options.length-1)).replaceAll('\\"','"').replace("\"separador\":\",,","\"separador\":\",\",").replace('}"','}');
							options = JSON.parse(options);
						}
						else if ( options.tipusFile!==".json" && options.style===undefined && typeof (options) !== "object"){
							if (options.indexOf("\\\"")>-1) options = options.replaceAll("\\\"","\"");
							options = JSON.parse(options);
						}	
					}
					catch(err) {				
						options=layer.options;
					}
				}
			}else{
				options = layer.options;	
			}
			return options;
		}
	}

	InstamapsUtils.Dom = Dom;

	class Cookie {
		constructor (){
		
		}

		//TODO refactoring para que no dependa de tantas librerias y que solo retorne valores que luego se pueden usar para hacer los redirect
		static gestioCookie (from, paramUrl, Cookies, url){
			var _cookie = Cookies.get('uid');
			var isRandomUsr = Validator.isRandomUser(_cookie);
			
			switch(from){
				case 'createMap':
					if (isRandomUsr){
						Cookies.remove('uid');
						window.location.href = paramUrl.mainPage;
					}else{
						//window.location.href = paramUrl.galeriaPage;
					}
					break;
				case 'createMapError':
					window.location.href = paramUrl.mainPage;
					break;
				case 'getMapByBusinessId2':
					if (isRandomUsr){
						Cookies.remove('uid');
						//jQuery(window).off('beforeunload');
						window.onbeforeunload = null;
						window.location.href = paramUrl.mainPage;
					}else{
						window.location.href = paramUrl.perfilPage;
					}
					break;
				case 'getMapByBusinessId':
					if (!_cookie){
						window.location.href = paramUrl.mainPage;
					}else{
						if (isRandomUsr){
							Cookies.remove('uid');
							//jQuery(window).off('beforeunload');
							window.onbeforeunload = null;
							window.location.href = paramUrl.mainPage;
						}else{
							//window.location.href = paramUrl.galeriaPage;
						}
					}
					break;
				case 'loadApp':
					if (!_cookie){
						window.location.href = paramUrl.mainPage;
					}
					break;
				case 'diferentUser':
					var mapacolaboratiu = url('?mapacolaboratiu');
					if (mapacolaboratiu && mapacolaboratiu=='si'){
						Cookies.set('collaborateuid', url('?uid'));
					}
					else{
						Cookies.remove('collaborateuid', { path: '/' });
						if (mapConfig.entitatUid != _cookie){
							Cookies.remove('uid');
							window.location.href = paramUrl.mainPage;
						}
					}
					break;
				case 'loadMapConfig':
					if (isRandomUsr){
						Cookies.remove('uid');
						//jQuery(window).off('beforeunload');
						window.onbeforeunload = null;
						window.location.href = paramUrl.mainPage;
					}else{
						//window.location.href = paramUrl.galeriaPage;
					}
					break;
				case 'carregaDadesUsuari':
					window.location.href = paramUrl.loginPage;
					break;
				case 'refrescaPopOverMevasDades':
					window.location.href = paramUrl.loginPage;
					break;
				case 'getMapByBusinessIdError':
					window.location.href = paramUrl.loginPage;
					break;
				case 'mapaBloquejat':
					//Temps vida cookie bloqueig: 2 hores
					Cookies.set('lockCookie', _cookie, {
						expires: 1/12
					});
					break;
			}	
		}
	}

	InstamapsUtils.Cookie = Cookie;

	class Mapa {
		constructor (){
		
		}

		static isCapaActiva (servidorsWMS, businessid){
			var capesActiva = false;
			var capaTrobada = false;
			servidorsWMS.forEach(function(value){
				if (value.businessId == businessid){
					capesActiva = value.capesActiva;
					capaTrobada = true;
				}
			});
			if (!capaTrobada) capesActiva = true;
			return capesActiva;
		}

		//NO TEST
		static getOptionsFinals (obj, propsCapaMare){
			var optionsFinals = [];
			if (obj!=undefined  && obj.options!=undefined) {
				if (obj.options.opcionsVis!=undefined) {
					optionsFinals[0] = obj.options.opcionsVis;
					optionsFinals[1] = obj.options;
				}
				else if ( obj.options.opcionsVisEtiqueta!=undefined) {
					optionsFinals[0]  = obj.options.opcionsVisEtiqueta;
					optionsFinals[1]  = obj.options;
				}
				else if (propsCapaMare!=undefined && propsCapaMare.opcionsVis) {
					optionsFinals[0] =propsCapaMare.opcionsVis;
					optionsFinals[1]  = propsCapaMare;
				}
				else if (propsCapaMare!=undefined && propsCapaMare.opcionsVisEtiqueta) {
					optionsFinals[0] =propsCapaMare.opcionsVisEtiqueta;
					optionsFinals[1]  = propsCapaMare;
				}
			}
			return optionsFinals;
		}

		//NO TEST
		static changeWMSQueryable (queryable, map){	
			map.eachLayer(function (layer) { 
			  	try{	 
			 		layer.options && layer.options.tipus && layer.options.tipus=='wms'? layer.options.queryable = queryable : null;	 
			  	}catch(err){
					console.debug(err);
			  	}
			});
		}

		//TODO el caso de modificación nose usa en el codigo
		static actualitzarServidorsWMS (businessid, accio, servidor, visibilitat, servidorsWMS){
			var newServidorsWMS;
			if (servidorsWMS !== undefined){
				switch (accio){
					case "alta":
						var existeixServidor = false;
						servidorsWMS.forEach(function(value){
							value = Dom.cleanOptions(value);
							if (servidor !== null && value!=undefined && value.businessId!=undefined && value.businessId == servidor.businessId){
								existeixServidor = true;			
							}
						});
						if (!existeixServidor) {
							newServidorsWMS = servidorsWMS.concat([servidor]);
						}
						break;
					case "baixa":
						newServidorsWMS = servidorsWMS.filter(function(value){	
							var mantener = true;
							value = Dom.cleanOptions(value);
							if (value!=undefined && value.businessId!=undefined && value.businessId == businessid){
								mantener = false;
							}
							return mantener;
						});
						break;
					case "modificacio":
						newServidorsWMS = servidorsWMS.map(function(value){
							value = Dom.cleanOptions(value);
							if (value!=undefined && value.businessId!=undefined && value.businessId == businessid){
								value.capesActiva = visibilitat;
							}
							return value;
						});
						break;
				}
			}
			return newServidorsWMS || servidorsWMS;
		}

		static getLeafletIdFromBusinessId (businessId, controlCapes){
			if(controlCapes){
				var key = null;
				Object.keys(controlCapes._layers).forEach(function (item) {
					if(controlCapes._layers[item].layer.options.businessId == businessId){
						key = item;
					}
				});
				return key;
			}			
		}

		//NO TEST
		static activaPanelCapes (obre, $) {	
			if (obre) {
				$('.leaflet-control-layers').show();
			} else {
				$('.leaflet-control-layers').hide();
			}
			var cl, btnDiv;
			if($('.bt_llista span')){
				btnDiv = $('.bt_llista span');
			}else{
				btnDiv = $('#dv_bt_layers');
			}
			cl = btnDiv.attr('class');
			if (cl && cl.indexOf('grisfort') != -1) {
				btnDiv.removeClass('grisfort');
				btnDiv.addClass('greenfort');
			} else {
				btnDiv.removeClass('greenfort');
				btnDiv.addClass('grisfort');
			}
		}

		//NO TEST
		static closePopup ($, map){
			$('#sidebar').attr("class","unactive");
			$('.leaflet-control-scale.leaflet-control').removeClass("popup-active");
			map.closePopup();
		}

		//NO TEST
		static controlarBloqueigMapa ($, url, Cookies, lockController, runningActions, dfdFunction){
			var controller = SessionTimeout({
				warnAfter: 28700000, //desenv: 10000,//prod: 28700000,
				redirAfter: 28800000, //desenv: 15000,//prod: 8 hores = 28800000 ms
				ignoreUserActivity: true,
				keepAlive: false,
				logoutButton: window.lang.translate("Sortir"),
				title: window.lang.translate("Desbloquejar mapa"),
				message: window.lang.translate("Han transcorregut 8 hores des que heu iniciat la sessió de treball. Premeu 'Continuar treballant' per mantenir-la oberta, o 'desbloquejar' per alliberar el mapa. Si no responeu, el mapa quedarà alliberat en 3 minuts."),
				onWarn: function(){
				},
				onRedir: function () {
					timeoutBloqueig = window.setTimeout(function(){
						treureBloqueigMapa($, url, Cookies, lockController, runningActions, dfdFunction);
					}, 28980000);//desenv: 30000); //prod: 8 hores i 3 minuts = 28980000 ms
					$('#dialog_bloqueig_mapa').modal('show');   
				}
			});
			return controller;
		}

		//NO TEST
		static refrescarCapesEtiquetes (controlCapes, mapConfig, map, $){
			$.each(controlCapes._layers, function(i, obj){
				Mapa.refrescarZoomEtiquetes(obj.layer, null, mapConfig, map, $);
				var propsCapaMare = obj.layer.options;
				$.each(obj._layers, function(i, lay){
					Mapa.refrescarZoomEtiquetes(lay.layer, propsCapaMare, mapConfig, map, $);
				});
			});
		}

		//NO TEST
		static refrescarZoomEtiquetes (obj, propsCapaMare, mapConfig, map, $){
			try{
				var optionsVis,options;
				var zoomInicial = zoomInicialEt;
				var zoomFinal = zoomFinalEt; 
				var businessId;
				
				if (obj!=undefined && obj.options!=undefined) businessId=obj.options.businessId;
				var inputLayer , checked;
				if (businessId!=undefined) inputLayer= $('#input-'+businessId);
				if (inputLayer!=undefined)  checked = inputLayer[0].checked;	
				propsCapaMare = InstamapsUtils.Dom.cleanOptions(propsCapaMare);
				

				var optionsFinals = Mapa.getOptionsFinals(obj,propsCapaMare);
				optionsVis = optionsFinals[0];
				options = optionsFinals[1];
			
				var isCapaActiva1 = true;
				if (mapConfig.servidorsWMS!=undefined && mapConfig.servidorsWMS.length>0) {
					isCapaActiva1 = ("true" === Mapa.isCapaActiva(mapConfig.servidorsWMS, businessId)  || true===Mapa.isCapaActiva(mapConfig.servidorsWMS, businessId));
				}
				if (obj!=undefined && optionsVis!=undefined && options!=undefined){
						
						 zoomInicial = options.zoomInicial;
						 zoomFinal = options.zoomFinal;
						 if ( map.getZoom()>=zoomInicial &&  map.getZoom() <= zoomFinal) {//mostrem labels
							 if (inputLayer!=undefined && isCapaActiva1)  {	 	
								 Mapa.showLabels(optionsVis, obj, $);
								 if (checked && !map.hasLayer(obj)) {
									 map.addLayer(obj);
									 
								 }
								 else if ( !map.hasLayer(obj)){
									 inputLayer.click();
									 map.addLayer(obj);		
								 }							
							 
							 }else {
								 Mapa.hideLabels(optionsVis, obj, $);
								 if (checked){
									inputLayer.click();
									map.removeLayer(obj);
								}
								else{
									map.removeLayer(obj);
								}
							 }
							 
							 
						}	
						  else {//amaguem labels
							if (map.hasLayer(obj)){
								Mapa.hideLabels(optionsVis, obj, $);
								map.removeLayer(obj);
							}
						 }
				}
				else if (obj!=undefined && options!=undefined){ //no tenim opcions d'etiqueta
					if ( map.getZoom()>=zoomInicial &&  map.getZoom() <= zoomFinal) {
						if (inputLayer!=undefined && isCapaActiva1)  {
							if (checked && !map.hasLayer(obj)) {
								 map.addLayer(obj);		 					
							 }
							else if ( !map.hasLayer(obj)){
								 inputLayer.click();
								 map.addLayer(obj);	
							 }
						}
					}
					else {				
						 if (map.hasLayer(obj)){
							map.removeLayer(obj);
						}
					}
				}
			}catch(e){
			}
		}

		//NO TEST
		static redimensioMapa ($, url, id) {
			$(window).resize(function() {
				var factorW = 0, 
				factorH = 0;
				
				if(typeof url('?embed') == "string"){//Pel cas visor, embeded
					factorH = 0;
				}
				$(id).css('top', factorH + 'px'); //#map
				$(id).height(jQuery(window).height() - factorH);
				$(id).width(jQuery(window).width() - factorW);
			});
			$(window).trigger('resize');
		}

		//NO TEST
		static hideLabels (optionsVis, obj, $){
			if (optionsVis=="nomesetiqueta" ||
				optionsVis=="etiquetageom") {
				if (obj._layers!=undefined){
					$.each(obj._layers, function(lay){					
						if(lay.label){
							lay.label.setOpacity(0);
						}
						else if (lay._tooltip!=undefined){
							lay.closeTooltip();
						}
					});
				}
			}
		}

		//NO TEST
		static showLabels (optionsVis, obj, $){
			if (optionsVis=="nomesetiqueta" ||
				optionsVis=="etiquetageom") {
				if (obj._layers!=undefined){
					$.each(obj._layers, function(lay){
						if (optionsVis=="nomesetiqueta" ||
								optionsVis=="etiquetageom") {
							if (lay.label!=undefined) {
								if(lay.label){
									lay.label.setOpacity(1);
								}								
								if(lay._showLabel){
									lay._showLabel({latlng: lay.label._latlng});
								}
							}
							else if (lay._tooltip!=undefined){
								lay.openTooltip();
							}
						}
					});
				}
			}
		}

		//NO TEST
		static treureBloqueigMapa ($, url, Cookies, lockController, runningActions, dfdFunction){
			var dfd = $.Deferred();
			var mapData = {
				businessId: url('?businessid'),
				uid: Cookies.get('uid')
			};
			dfdFunction(mapData).then(function(results){ //desbloquejarMapa
				if (results.status=="OK"){
					$.when.apply(null, runningActions).done(function() {
						lockController.stop();
						if(($("#dialog_bloqueig_mapa").data('bs.modal') || {}).isShown){
							$('#dialog_bloqueig_mapa').modal('hide');
							window.location.href = paramUrl.perfilPage;
						}else{
							dfd.resolve();
						}
					});
				}else{
					dfd.reject();
				}
			});
			return dfd.promise();
		}

		//NO TEST
		static getAtributionControlHtml(map) {
			/*return (map && 
				map.attributionControl && 
				map.attributionControl.options &&
				map.attributionControl.options.prefix) ? 
				map.attributionControl.getContainer() : 
				"";*/
			return (map && 
				map.attributionControl &&
				map.attributionControl.text) ? 
				map.attributionControl.text : 
				"";	
		}

		static findLayerByBusinessId(businessId){
			var defer = $.Deferred();
			if(controlCapes){		
				$.each( controlCapes._layers, function(i,val) {//busquem capa per businessId
					var layer = val.layer;
					if (layer.options.businessId==businessId){			
						defer.resolve(layer);
					}		
				});		
			}
			else{
				if (window.anf.default.instamapsVisorApp.$children[0]) {
					var viewer = getInstamapsMapViewer();
					var _layers = viewer.layers;
					jQuery.each(_layers, function (i, item) {
						jQuery.each(item.layers, function (i2, item2) {
							if (item2.businessId === businessId) {
								defer.resolve(item2);
							}
						});
					});
				}
			}
			return defer.promise();
		}

		static saveEditedLayer(e){
			if(objEdicio.esticEnEdicio){	
				for(var i = 0;i < guideLayers.length; i++) {			
			
					if (guideLayers[i].snapediting!=undefined)  guideLayers[i].snapediting.disable();
					if (guideLayers[i].editing!=undefined) guideLayers[i].editing.disable();
					try{
						if (guideLayers[i].dragging!=undefined) guideLayers[i].dragging.disable();
					}catch(exc){
							
					}
				}
			
					
				try{
					if(crt_Editing){
						try{
							crt_Editing.disable();							
						}catch(exc){
							
						}
					}
					updateFeatureMove(objEdicio.featureID, crt_Editing._featureGroup._leaflet_id, objEdicio.capaEdicioLeafletId).then(function(){
						actualitzarComboCapes();
					});
				}catch(exc){
					
				}
				
			}			
			if(crt_Editing){
				try{
					crt_Editing.disable();
				}catch(exc){
					
				}
			}
		}

		static openPopupOnClick(e){
			if ($('#sidebar').attr("class")==='unactive'){
				PopupManager().createMergedDataPopup(e.target, e, controlCapes).then(function(results) {
					if(results !== '<div id="popup-mng" class="popup"><div class="tab-content"></div></div>') {
						$('.sidebar-body').html(results);
						if ($('#sidebar').attr("class")==='unactive'){
							$('#sidebar').attr("class","active");
							$('.leaflet-control-scale.leaflet-control').addClass("popup-active");
						}
					} else {
						InstamapsUtils.Mapa.closePopup(jQuery, map);
					}
					PopupManager().addComboAndEvents();
				});	
			}
		}

		static findFeatureByBusinessId(businessId){
			var defer = $.Deferred();
			
			var viewer = getInstamapsMapViewer();
			var _layers = viewer.layers;
			jQuery.each(_layers, function (i, item) {
				jQuery.each(item.layers, function (i2, item2) {
					if (item2.businessId === businessId) {
						defer.resolve(item2);
					}
				});
			});
			
			return defer.promise();
		}
		
		static loadSpiner(noWMS){		
			var dfd = $.Deferred();	
			$.get("/static/geocatweb/templates/modalLoadingLayers.html",function(data){
				$('#mapa_modals').append(data);				
				if (noWMS) $('#div_loading').modal('show');			
				dfd.resolve();
			});
			return dfd.promise();
		}

		static hideSpiner(){
			$('#div_loading').modal('hide');
			jQuery('#div_loading').hide();
			try{
				document.querySelectorAll("#div_loading").forEach(el => el.remove());
			}catch(e){ 

			}
			if (map._spinner!==null) {
				map._spinner.stop();
				map._spinner = null;
			}
			
		}	 
		
		static hiHaServeisWMS(servidorsWMS){
			var hiHaServeis = false;
			servidorsWMS.forEach(function(value){
				if (value.serverType == "wms"){
					hiHaServeis = true;
					return;
				}
			});
			return hiHaServeis;
		}
		
	}

	InstamapsUtils.Mapa = Mapa;

	class UrlUtils {
		constructor (){
		
		}
		/* * @param {String} str - string
		   * @return {String} base64 encoded
		 */
		static stringToBase64(str){
			return window.btoa(str);
		}

		/* * @param {String} base64 - string en base64
		   * @return {String} str decoded
		 */
		static base64ToString(base64){
			return window.atob(base64);
		}	  
		/* * @param {String} str -string
		   * @return {String} base64 encoded
		 */
		static encode(str){
		  var base64 = UrlUtils.stringToBase64(str);
		  return base64.replace(/[+/=]/g, (m) => ENC[m]);
		}
		  
		/* * @param {String} safe - base64 string
		   * @return {String} base64 decoded
		*/
		static decode(safe){
			return UrlUtils.base64ToString(safe.replace(/[-_.]/g, (m) => DEC[m]));
		}	
		
		static getContextMapsUrl(urlMap){
			var urlMapEncoded = UrlUtils.encode(urlMap);
			return urlContextMaps+"openlink="+urlMapEncoded;
		}
	}

	InstamapsUtils.UrlUtils = UrlUtils;

	if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
		module.exports = InstamapsUtils;
	} else {
		window.InstamapsUtils = InstamapsUtils;
	}

})();



//////////////////
// WEBPACK FOOTER
// ../original/geocatweb/js/instamaps.utils-3.0.0.js
// module id = 331
// module chunks = 0